// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5fGtk","content":"styles_content__2y71A","tableWrap":"styles_tableWrap__16QgF"};